import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  isList: boolean = true;
  isPanel: boolean = false;
  location: string = 'All';
  isView: boolean = false;
  selectedFilter = true;
  isRightbarHidden = false;
  /** Universal browse/search filter state (category path + price/location/keyword + attributes). */
  listingFilter = {
    profile: null,
    username: null,
    isProfileLoggedIn: null,
    minPrice: null,
    maxPrice: null,
    category: null,
    subcategory: null,
    subSubcategory: null,
    subSubSubcategory: null,
    subSubSubSubcategory: null,
    subSubSubSubSubcategory: null,
    subSubSubSubSubSubcategory: null,
    subSubSubSubSubSubSubcategory: null,
    subSubSubSubSubSubSubSubcategory: null,
    paramId: null,
    location: null,
    sale: null,
    page: null,
    size: null,
    pageSize: null,
    totalCount: 20000000,
    orderBy: null,
    id: null,
    endUser: null,
    keyword: null,
    attributes: {}
  };
}
